import {defineMessages} from 'react-intl';

export const messages = defineMessages({
    1: {
        id: 'day.mon',
        defaultMessage: 'Monday'
    },
    2: {
        id: 'day.tue',
        defaultMessage: 'Tuesday'
    },
    3: {
        id: 'day.wed',
        defaultMessage: 'Wednesday'
    },
    4: {
        id: 'day.thu',
        defaultMessage: 'Thursday'
    },
    5: {
        id: 'day.fri',
        defaultMessage: 'Friday'
    },
    6: {
        id: 'day.sat',
        defaultMessage: 'Saturday'
    },
    7: {
        id: 'day.sun',
        defaultMessage: 'Sunday'
    },
});

export default messages;
